// extracted by mini-css-extract-plugin
module.exports = {"main":"Layout-module--main--3UpD3","gradientBackground":"Layout-module--gradientBackground--3MUQW"};